import React from 'react';
import { ColorPropsEnum } from '../../types';
export var IconBookOpen4 = _ref => {
  var {
    size,
    strokeWidth = 1.5,
    color = ColorPropsEnum.black
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    version: "1.1",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: strokeWidth,
    stroke: color,
    fill: "none",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.75,4.9c-0.913,0.315 -1.814,0.722 -2.75,1.247c-2.594,-1.454 -4.912,-2.032 -7.983,-2.131c-0.558,-0.018 -1.017,0.442 -1.017,1v11.837c0,0.541 0.433,0.99 0.974,0.998c3.092,0.047 5.42,0.617 8.026,2.149c2.606,-1.532 4.934,-2.102 8.026,-2.148c0.541,-0.008 0.974,-0.457 0.974,-0.999v-11.837c0,-0.559 -0.459,-1.018 -1.017,-1c-0.606,0.02 -1.177,0.064 -1.733,0.124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.061,3.016c-0.551,0.098 -1.085,0.223 -1.61,0.376c-0.42,0.122 -0.701,0.521 -0.701,0.958v4.196l1.75,-1.167l1.75,1.167v-4.543c0,-0.626 -0.572,-1.097 -1.189,-0.987Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,6.15v13.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,13.773c0.961,-0.319 1.946,-0.522 3,-0.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,13.133c1.054,0.117 2.039,0.321 3,0.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,9.773c-0.961,-0.319 -1.946,-0.523 -3,-0.64"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0,0h24v24h-24Z"
  }));
};
//# sourceMappingURL=IconBookOpen4.js.map